import { ArrowBackIos, ContentCopy, FileDownload } from '@mui/icons-material';
import React, { useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useNavigate } from 'react-router-dom';
import Strings from '../../../i18n';
import { PasswordResetInfo } from '../../../types/passwordResetInfo';
import { Header } from '../../../components/header/header';
import {
  ContainerStyled,
  ContainerTable
} from '../../../components/layout/main/mainStyles';
import {
  ButtonIconStyled,
  TitleStyled
} from '../../../views/devices/devicesStyles';
import { useGetUsersPasswordResetMutation } from '../../../services/users/usersService';
import { utcToBrowserDate } from '../../../utils/date';
import { StatusResetPassword } from '../../../constants/statusResetPassword';

export const UserResetPassword = () => {
  const navigate = useNavigate();

  const [getUsersPassword, { data, isSuccess }] =
    useGetUsersPasswordResetMutation();

  useEffect(() => {
    getUsersPassword();
  }, []);

  const getDateFormat = (rowData: PasswordResetInfo) => {
    return utcToBrowserDate(rowData.date);
  };

  const statusLabels: Record<StatusResetPassword, string> = {
    [StatusResetPassword.pending]: 'Pending',
    [StatusResetPassword.read]: 'Readed',
    [StatusResetPassword.used]: 'Completed'
  };

  const getStatus = (rowData: PasswordResetInfo) => {
    return <span>{statusLabels[rowData.status]}</span>;
  };

  const getUrl = (rowData: PasswordResetInfo) => {
    return (
      <a href={rowData.urlSent} target="_blank" rel="noopener noreferrer">
        {rowData.urlSent}
      </a>
    );
  };

  return (
    <>
      <Header>
        <ContainerStyled>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <ButtonIconStyled size="small" onClick={() => navigate(-1)}>
                <ArrowBackIos />
              </ButtonIconStyled>
            </div>
            <div className="col-4 text-center">
              <TitleStyled>{Strings.users.usersResetPassword}</TitleStyled>
            </div>
            <div className="col-8 col-sm-4 text-right" />
          </div>
        </ContainerStyled>
      </Header>
      <ContainerTable component="main">
        {data && isSuccess && (
          <DataTable
            data-testid="table"
            value={data}
            size="small"
            scrollable
            scrollHeight="flex"
            selectionPageOnly
            tableStyle={{ fontSize: '14px' }}
          >
            <Column field="date" header="Date" sortable body={getDateFormat} />
            <Column field="email" header="Email Address" sortable />
            <Column field="urlSent" header="URL" sortable body={getUrl} />
            <Column
              field="openedResetUrl"
              header="status"
              sortable
              body={getStatus}
            />
          </DataTable>
        )}
      </ContainerTable>
    </>
  );
};
